export default function (container, header, dontOverlap) {
  const floatingContainer = document.querySelector(container);
  const siteHeader = document.querySelector(header);
  const dontOverlapElement = document.querySelector(dontOverlap);

  if (!floatingContainer) {
    return;
  }

  // Styles for the floating container to be floating. The rest can be done in CSS
  floatingContainer.style.position = 'fixed';
  floatingContainer.style.bottom = 0;

  // ==== Dont Overlap Element (footer) - Intersection Observer ====
  // When the footer is on screen, the floating container will get bottom padding to avoid overlapping

  const observerOverlap = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          floatingContainer.classList.add('is-overlapping');
        } else {
          floatingContainer.classList.remove('is-overlapping');
        }
      });
    },
    {
      root: null,
      // everyday we stray further from god
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    },
  );

  observerOverlap.observe(dontOverlapElement);

  // ==== Header - Intersection Observer ====
  // Hide/show the floating container depending on if the header is visible
  const observerHeader = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          floatingContainer.classList.add('is-visible');
          floatingContainer.classList.remove('is-hidden');
        } else {
          floatingContainer.classList.add('is-hidden');
          floatingContainer.classList.remove('is-visible');
        }
      });
    },
    {
      root: null,
      threshold: 0,
    },
  );

  observerHeader.observe(siteHeader);
}
